import React, { useEffect, useState } from "react";
import { useExperience } from "../resume/useResumeData";
import Modal from "../../ui/Modal";

const ExperienceModal = ({ itemToEdit, onClose }) => {
    const { addExperience, updateExperience, isAdding, isUpdating } = useExperience();
    const [formData, setFormData] = useState({
        role: "",
        company: "",
        location: "",
        year_range: "",
        description: "",
        ordering: 0,
    });

    useEffect(() => {
        if (itemToEdit) {
            setFormData({
                role: itemToEdit.role || "",
                company: itemToEdit.company || "",
                location: itemToEdit.location || "",
                year_range: itemToEdit.year_range || "",
                description: itemToEdit.description || "",
                ordering: itemToEdit.ordering || 0,
            });
        }
    }, [itemToEdit]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (itemToEdit) {
            updateExperience(
                { id: itemToEdit.id, ...formData },
                { onSuccess: onClose }
            );
        } else {
            addExperience(formData, { onSuccess: onClose });
        }
    };

    const isLoading = isAdding || isUpdating;

    return (
        <Modal
            isLoading={isLoading}
            onClose={onClose}
            title={itemToEdit ? "Edit Experience" : "Add Experience"}
        >
            <form onSubmit={handleSubmit} className="space-y-6 font-primary text-white">
                <div className="space-y-6">
                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Role/Title</label>
                        <input
                            type="text"
                            required
                            className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.role}
                            onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                            placeholder="e.g. Senior Frontend Developer"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-6">
                        <div>
                            <label className="mb-2 block text-sm font-medium text-stone-300">Company</label>
                            <input
                                type="text"
                                required
                                className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                                value={formData.company}
                                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                                placeholder="e.g. Google"
                            />
                        </div>
                        <div>
                            <label className="mb-2 block text-sm font-medium text-stone-300">Location</label>
                            <input
                                type="text"
                                className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                                value={formData.location}
                                onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                                placeholder="e.g. London, UK"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Year Range</label>
                        <input
                            type="text"
                            required
                            className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.year_range}
                            onChange={(e) => setFormData({ ...formData, year_range: e.target.value })}
                            placeholder="e.g. 2022 - Present"
                        />
                    </div>

                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Description</label>
                        <textarea
                            rows="4"
                            className="w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Responsibilities and achievements..."
                        />
                    </div>
                </div>

                <div className="flex justify-end pt-4">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="btn flex min-w-[8rem] items-center justify-center border-none bg-gradient-to-tr from-sky-600 to-cyan-400 py-3 font-semibold uppercase text-white shadow-lg hover:from-cyan-400 hover:to-sky-600 active:scale-95 disabled:opacity-50 transition-all rounded-lg"
                    >
                        {isLoading ? "Saving..." : (itemToEdit ? "Update Experience" : "Save Experience")}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ExperienceModal;
